import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex flex-wrap gap-3 mb-6">
      {categories?.map((category, index) => (
        <motion.button
          key={category?.id}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.1, duration: 0.3 }}
          onClick={() => onCategoryChange(category?.id)}
          className={`flex items-center gap-2.5 px-5 py-3 rounded-xl text-sm font-semibold transition-all duration-300 ${
            activeCategory === category?.id
              ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/50 scale-105'
              : 'bg-slate-800/50 text-slate-300 hover:bg-slate-800 hover:text-white hover:scale-105 border border-teal-500/20'
          }`}
        >
          <Icon name={category?.icon} size={18} color="currentColor" />
          <span>{category?.name}</span>
          <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${
            activeCategory === category?.id
              ? 'bg-white/20' :'bg-teal-500/20 text-teal-400'
          }`}>
            {category?.count}
          </span>
        </motion.button>
      ))}
    </div>
  );
};

export default CategoryFilter;